import React, { useRef } from 'react';

import { useClickOutside } from './useClickOutside';

interface Props {
  onClickOutside: (e: PointerEvent) => void;
  children: React.ReactNode;
  triggerOn?: 'pointerdown' | 'pointerup';
}

export function ClickOutside(props: Props) {
  const container = useRef<HTMLDivElement>(null);
  const { onClickOutside, triggerOn, ...restProps } = props;

  useClickOutside({ containerRef: container, onClickOutside, triggerOn });

  return (
    <div {...restProps} ref={container}>
      {props.children}
    </div>
  );
}
